import { useState } from "@wordpress/element";
import useSWR from "swr";
import { fetcher } from "../fetcher";
import qs from "qs";
import { Article, Skeleton } from "./components/article";

export function Block({ count = 3, ...props }) {
	const [state, set] = useState(Number(count));

	const params = qs.stringify(
		{ count: state, include_career_paths: false, ...props },
		{
			addQueryPrefix: true,
		},
	);

	const { isLoading, data } = useSWR(
		`/wp-json/steam-api/articles${params}`,
		fetcher,
	);

	const content = data?.content ?? [];

	return (
		<>
			{isLoading && [...Array(state)].map((_, i) => <Skeleton key={i} />)}

			{!isLoading &&
				content.map((post) => <Article key={post.ID} article={post} />)}

			{!isLoading && content.length === 0 && <>Brak artykułów</>}
		</>
	);
}
